import { DISMISS_APP } from '../constants/system-external-events';

/**
 * Creates message for visa-sdk with DISMISS_APP event.
 * This is used when System SDK needs to dismiss the app based on XHR or other parsing error
 before user has been routed to a specific app / DCF screen.
 *
 * @returns {Object} message
 */
const getDismissAppMessage = () => {
  return {
    type: DISMISS_APP
  };
};

export default getDismissAppMessage;
